import { render, staticRenderFns } from "./UserContact.vue?vue&type=template&id=f3fd8348&"
import script from "./UserContact.vue?vue&type=script&lang=js&"
export * from "./UserContact.vue?vue&type=script&lang=js&"
import style0 from "./UserContact.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports